// import { observable, action } from 'mobx';

import { observable, action } from "mobx";
import { IInstance } from "../../../interfaces/IInstance";
import { Helper } from "../../../Helper";
import { IUser } from "../../../interfaces/IUser";
import { MessagesStore } from "../../messages/stores";

export class AppStore {
  @observable public token: string;
  @observable public environment: "Development" | "Test" | "Production";
  @observable public tenant: string;
  @observable public preview: boolean = false;
  @observable public isIPhoneXType = this.preview ? false : Helper.isIPhoneXType();
  @observable public blockReload: boolean = false;
  @observable public editMode: boolean;

  @observable public instance: IInstance;

  @observable public showMenu: boolean;
  @observable public showSettings: boolean;

  @observable public user: IUser;

  @observable public pages: JSX.Element[][];
  @observable public selectedPageIndex: number;
  @observable public selectedComponentIndex: number;

  @observable public contentMapPageToShow: string;

  @observable public isCustomApp: boolean;
  @observable public nativeVersion: string;

  @observable public openedPanelMessageStore: MessagesStore;

  @observable public showPowerApp: boolean;

  @action public reloadPage(): void {
    if (!this.blockReload) {
      if (this.selectedPageIndex === undefined) {
        this.selectedPageIndex = 0;
      }
      const tempIndex = this.selectedPageIndex;
      this.pages[this.selectedPageIndex] = undefined;
      this.selectedPageIndex = undefined;
      setTimeout(() => {
        this.selectedPageIndex = tempIndex;
      }, 0);
    }
  }
}